import { ReactComponent as FlagIcon } from "./svg/pa-flag.svg";
import "../flag-icon.scss";

export const PAFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
